import { getLink } from "../../../utils/utils";

import translator from "./translator";

const cite1Text = (
  `S.E. – Sergeo Efron, la edzo de M. Cvetajeva`
)
const cite1 = (
  `<sup><acronym title="${cite1Text}"><a href="#cite_note1" id="cite_ref1">[1]</a></acronym></sup>`
)

const content = {
  esp: (
    `
    <h4 class="mb-3 bold text-center">Poemo, verkita en mia naskiĝtago</h4>

    
    <div class="poem">
      <p class="poem-block mb-3">
        Animo en dolor’, <br/>
        Kolero pro la am’. <br/>
        Ĉehio en la plor’, <br/>
        Madrido en la flam’.
      </p>

      <p class="poem-block mb-3">
        Minacas nigra mont’ <br/>
        Al tuta hela lum’. <br/>
        Pro abomen’ kaj hont’ <br/>
        Ne sonu tedeum’.
      </p>

      <p class="poem-block mb-3">
        Rezigno al ekzist’! <br/>
        En la malhoma get’ <br/>
        Mi vivu por rezist’! <br/>
        Kun lupoj de parget’
      </p>

      <p class="poem-block mb-3">
        Ne hurlu mi en ĥor’. <br/>
        Kun ŝarkoj de servil’ <br/>
        Ne flosu mi laŭ flu’ <br/>
        Malsupren, kun humil’.
      </p>

      <p class="poem-block mb-3">
        Mi ne bezonas tru- <br/>
        ojn por la flar’ kaj vid’. <br/>
        Al monda plendetru’ <br/>
        Respondo nur – rezist’!
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Mi scias la veron…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Mi scias la veron! Antaŭajn verojn – for! <br/>
        Ne devas okazi de homo kun hom’ bataloj. <br/>
        Rigardu: vespero, baldaŭ la nokta hor’. <br/>
        Pri kio – poetoj, amantoj kaj generaloj?
      </p>

      <p class="poem-block mb-3">
        Jam vent’ susuras, jam rosojn sternas juni’, <br/>
        Jen venas stela blizard’ en ĉielon glacian, <br/>
        Kaj sub la tero baldaŭ ekdormos ni, <br/>
        Ĉiuj, kiuj surtere ne lasis endormi unu l’ alian.
      </p>
    </div>
    

    <h4 class="mt-5 mb-3 bold text-center">El templo severe aspekta…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        El templo severe aspekta <br/>
        Vi venis al placa tumult’… <br/>
        – Libero! – la Damo Perfekta, <br/>
        De ĉiaj nobluloj belkult’.
      </p>

      <p class="poem-block mb-3">
        Okazas terura kunkanto, – <br/>
        Anstataŭ la meso – milit’! <br/>
        – Libero! – putin’ provokanta <br/>
        Sur brust’ de ebria bandit’!
      </p>
    </div>
    

    <h4 class="mt-5 mb-3 bold text-center">Kie la cignoj…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        – Kie la cignoj? – Ili iris for. <br/>
        – Kaj korvoj? – Ilin ni plu devos havi. <br/>
        – Kien la cignoj iris? – Flugis sor. <br/>
        – Por kio? – Por flugilojn blankajn savi.
      </p>

      <p class="poem-block mb-3">
        – Kaj kie paĉjo? – Dormu sub ikon’, <br/>
        Tuj la ĉeval’ mirakla sonĝon trenos. <br/>
        – Kien veturos ni? – Al cigna Don’, <br/>
        Al blanka cigno mia ni alvenos.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Ve al vi, aristokratoj…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Ve al vi, aristokratoj, <br/>
        La riĉuloj – en deprim’. <br/>
        Sed mi antaŭ la soldatoj <br/>
        Ne kliniĝos pro ektim’.
      </p>

      <p class="poem-block mb-3">
        L’ urbo ĝemas kaj rabias, <br/>
        Lun’ – en vina atmosfer’. <br/>
        Sed plebanojn mi defias, <br/>
        Mi, fiera en mizer’.
      </p>
    </div>


    <h4 class="mt-5 bold text-center">La poemo 8…</h4>
    <p class="mb-3 italic text-center">(El la ciklo «Versoj por Ĉeĥio (Marto)»)</p>


    <div class="poem">
      <p class="poem-block mb-3">
        L’ animo en dolor’! <br/>
        Kolero pro la am’! <br/>
        Ĉeĥio en la plor’! <br/>
        Madrido en la flam’!
      </p>

      <p class="poem-block mb-3">
        Minacas nigra mont' <br/>
        Al hela mond' per blind'! <br/>
        Redonu mi pro hont' <br/>
        Bileton de l' Kreint'.
      </p>

      <p class="poem-block mb-3">
        Mi negas je ekzist’: <br/>
        En la malhoma get’ <br/>
        Plu vivi sen rezist’, <br/>
        Kun lupa raba best’
      </p>

      <p class="poem-block mb-3">
        Kunhurli en la hord’, <br/>
        Kun ŝarka kamaril’ <br/>
        Kunflosi preter bord’– <br/>
        Malsupren – kun humil’.
      </p>

      <p class="poem-block mb-3">
        Mi ne bezonas tru- <br/>
        ojn por aŭd-vida uz’. <br/>
        Al monda plendetru’ <br/>
        Respondo nur - rifuz’!
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Obskurad’…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Obskurad’. – Uragan’. – Sodom’. <br/>
        Gardu Neston en via Dom’! <br/>
        Fideleco kaj nobla Dev’ <br/>
        Sentinelu por via serv’. <br/>
        Dio regu en via kor’, <br/>
        Blanka gardo por vi – l’ Honor’! <br/>
        Estu via domnest’ – insul’, <br/>
        Ke ne venu al ĝi – Fremdul’. <br/>
        Tomb’ de avo, ĝarden’ de fil’ – <br/>
        Savu ilin en la azil’! <br/>
        Altu spite al misa sort’ <br/>
        Kverk’ prapatra en via kort’!
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Mi portas lian ringon kun fier’…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        S. E.${cite1} <br/>
        Mi portas lian ringon kun fier’! <br/>
        – En Eternec’ – l’edzin’,  ne por parado! – <br/>
        Lia vizaĝ’ kun akra karakter’ – <br/>
        Kiel la spado. <br/>
        Senvortas lia buŝ’, dolora ark’, <br/>
        Tragike konkavitas liaj vangoj. <br/>
        Defie montras sin nobleca mark’ – <br/>
        Du praaj sangoj. <br/>
        Li sveltas per sveltec’ de juna kan’. <br/>
        Kiel abismoj logas la okuloj! – <br/>
        Sub brovoj – la flugiloj en elan’ – <br/>
        Du bluoj. <br/>
        Li – kavalir’, fidela mi vasal’, <br/>
        – Al ĉiuj, kiuj morton ne evitas! – <br/>
        Similaj – en la tempoj de fatal’– <br/>
        Poemojn verkas – eŝafodojn spitas.
      </p>
    </div>


    <h4 class="mt-5 bold text-center">Mortint’ revivos…</h4>
    <p class="mb-3 italic text-center">(El la ciklo «Don’»)</p>


    <div class="poem">
      <p class="poem-block mb-3">
      Mortint’ – revivos kaj vivinto – mortos. <br/>
      Kaj iam en futura lecion’: <br/>
      – «Kie vi estis?» – la demando tondros, <br/>
      Kaj ektondregos la respond’: «Ĉe Don’».
      </p>

      <p class="poem-block mb-3">
      – «Kion vi faris?» – «Staris ni martire, <br/>
      Laciĝis kaj endormis post opon’». <br/>
      Kaj en vortar’ enskribos nep’ admire <br/>
      Post vorto «Dev’» fieran vorton «Don’».
      </p>
    </div>

    <ol class="cites mb-3">
      <li id="cite_note1">
        <a href="#cite_ref1">↩</a>
        ${cite1Text}
      </li>
    </ol>
  `
  )
}

const itemName = {
  esp: 'Marina Cvetaeva'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;